import { Action } from '@ngrx/store';
import {
    PremiumPlace,
    Sponsor,
} from '@polaris-customerweb/sharedcomponents.map';
import { Club } from './club';

export const ClubAction = {
    addSponsor: '[club] add sponsor',
    removeSponsor: '[club] remove sponsor',
    setActiveSponsor: '[club] set active sponsor',
    setAllPremiumPlaces: '[club] set all premium places',
    setEditableSponsor: '[club] set editable sponsor',
    setOwnClubs: '[club] set own clubs',
    setOwnSponsors: '[club] set own sponsors',
    updateSponsor: '[club] update sponsor',
};

export class AddSponsor implements Action {
    type = ClubAction.addSponsor;
    constructor(public sponsor: Sponsor) {}
}

export class RemoveSponsor implements Action {
    type = ClubAction.removeSponsor;
    constructor(public sponsorId: string) {}
}

export class SetActiveSponsor implements Action {
    type = ClubAction.setActiveSponsor;
    constructor(public sponsor: Sponsor) {}
}

export class SetAllPremiumPlaces implements Action {
    type = ClubAction.setAllPremiumPlaces;
    constructor(public premiumPlaces: PremiumPlace[]) {}
}

export class SetEditableSponsor implements Action {
    type = ClubAction.setEditableSponsor;
    constructor(public sponsor: Sponsor | undefined) {}
}

export class SetOwnClubs implements Action {
    type = ClubAction.setOwnClubs;
    constructor(public clubs: Club[]) {}
}

export class SetOwnSponsors implements Action {
    type = ClubAction.setOwnSponsors;
    constructor(public sponsors: Sponsor[]) {}
}

export class UpdateSponsor implements Action {
    type = ClubAction.updateSponsor;
    constructor(public sponsor: Sponsor) {}
}
